import React from 'react';
import { CheckCircle } from 'lucide-react';

const ProductFormats = () => {
  return (
    <section id="nutrition" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header with 2-in-1 Image */}
        <div className="mb-16">
          <div className="grid md:grid-cols-2 gap-8 items-center max-w-5xl mx-auto">
            {/* Left - Text */}
            <div className="text-center md:text-left">
              <p className="text-[#8B6F47] text-sm tracking-widest uppercase mb-4">
                Flexibility Built In
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-[#2C2416] mb-4">
                Bowl or Shake.
              </h2>
              <p className="text-2xl text-[#5C4033] mb-4">
                Your day. Your way.
              </p>
              <p className="text-lg text-[#8B6F47]">
                One formulation. Two formats. Built around real days, not ideal ones.
              </p>
            </div>
            
            {/* Right - Small 2-in-1 Image */}
            <div className="flex justify-center md:justify-end">
              <img
                src="https://d64gsuwffb70l.cloudfront.net/6851587676ae218610324179_1769273763163_4ab5f822.png"
                alt="2-in-1 Bowl or Shake"
                className="w-48 h-auto rounded-xl"
              />
            </div>
          </div>
        </div>

        {/* Product Cards */}
        <div className="grid md:grid-cols-2 gap-12">
          {/* Original - Bowl */}
          <div className="bg-[#F5F1E8] rounded-2xl overflow-hidden hover:shadow-xl transition-shadow">
            <div className="p-8">
              <img
                src="https://d64gsuwffb70l.cloudfront.net/6851587676ae218610324179_1769273867014_877dc38a.png"
                alt="GUAG Original - Bowl"
                className="w-full h-80 object-cover rounded-xl mb-6"
              />
              <div className="mb-4">
                <span className="text-xs text-[#8B6F47] uppercase tracking-wider font-semibold">
                  60 SECONDS · BOWL
                </span>
              </div>
              <h3 className="text-3xl font-bold text-[#2C2416] mb-4">
                Original Flavour
              </h3>
              <p className="text-[#5C4033] mb-6">
                When you have time to sit, savour, and start right.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3 text-[#5C4033]">
                  <CheckCircle className="text-[#8B6F47] flex-shrink-0 mt-0.5" size={20} />
                  <span>Slower digestion for sustained energy</span>
                </li>
                <li className="flex items-start gap-3 text-[#5C4033]">
                  <CheckCircle className="text-[#8B6F47] flex-shrink-0 mt-0.5" size={20} />
                  <span>Morning ritual that grounds your day</span>
                </li>
                <li className="flex items-start gap-3 text-[#5C4033]">
                  <CheckCircle className="text-[#8B6F47] flex-shrink-0 mt-0.5" size={20} />
                  <span>Satisfying texture and fullness</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Chocolate - Shake */}
          <div className="bg-[#F5F1E8] rounded-2xl overflow-hidden hover:shadow-xl transition-shadow">
            <div className="p-8">
              <img
                src="https://d64gsuwffb70l.cloudfront.net/6851587676ae218610324179_1769273848420_b8fd2efd.png"
                alt="GUAG Chocolate - Shake"
                className="w-full h-80 object-cover rounded-xl mb-6"
              />
              <div className="mb-4">
                <span className="text-xs text-[#8B6F47] uppercase tracking-wider font-semibold">
                  60 SECONDS · SHAKE
                </span>
              </div>
              <h3 className="text-3xl font-bold text-[#2C2416] mb-4">
                Chocolate Flavour
              </h3>
              <p className="text-[#5C4033] mb-6">
                When life moves fast but nutrition can't wait.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3 text-[#5C4033]">
                  <CheckCircle className="text-[#8B6F47] flex-shrink-0 mt-0.5" size={20} />
                  <span>Ready in under a minute</span>
                </li>
                <li className="flex items-start gap-3 text-[#5C4033]">
                  <CheckCircle className="text-[#8B6F47] flex-shrink-0 mt-0.5" size={20} />
                  <span>Perfect for commutes and travel</span>
                </li>
                <li className="flex items-start gap-3 text-[#5C4033]">
                  <CheckCircle className="text-[#8B6F47] flex-shrink-0 mt-0.5" size={20} />
                  <span>Same complete nutrition, zero compromise</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductFormats;